// Steps sort by `order` ascending. New steps and steps moved under a new
// parent both take the current time, so they land after existing steps.
export const nextStepOrder = (now: number = Date.now()): number => now;
